<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('paymentTesting.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('paymentTesting.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button
            outline
            color="info"
            @click="$router.push({ name: 'payment-test-create' })"
            >{{ $t('add_new') }}</ts-button
          >
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
        <!-- drawer -->
        <a-drawer
          :title="$t('invoice.filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="() => (visible = false)"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <a-select
                  style="width: 257px"
                  v-model="branch_id"
                  :options="branchs"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                >
                </a-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <a-range-picker
                  format="DD-MM-YYYY"
                  :defaultValue="[dateFrom, dateTo]"
                  :defaultPickerValue="[dateFrom, dateTo]"
                  @change="dateRangeChange"
                >
                  <template slot="renderExtraFooter"></template>
                </a-range-picker>
              </div>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'branch.branch_name_en'
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">{{ record.payment_date }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.inquiry.full_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.payment_number }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.sub_program.acps_name_foreign }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.ac_term.term_name }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="mr-2 text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fa fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('pdf')"
                class="text-danger"
                @click.prevent="pdfView(record)"
              >
                <i class="fas fa-file-pdf"></i>
              </a>
              <a
                href="#"
                @click.prevent="deleteRecord(record)"
                :disabled="record._deleting"
              >
                <i
                  class="fas fa-circle-notch spin ml-2"
                  v-if="record._deleting"
                ></i>
                <i class="fa fa-trash ml-2 text-red" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- preview pdf -->
      <a-modal
        v-model="preview_pdf"
        :title="$t('pdf')"
        @cancel="closeModal"
        width="40%"
        :maskClosable="false"
        :footer="null"
        :zIndex="1020"
      >
        <preview-pdf-component :id="id" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'
import { Errors } from 'form-backend-validation'
import Reason from './components/reason_delete'
import PreviewPdfComponent from './components/pdf-preview'
import moment from 'moment'

export default {
  name: 'paymentTesting',
  components: {
    PreviewPdfComponent
  },
  data () {
    return {
      loading: false,
      visible: false,
      preview_pdf: false,
      id: null,
      branchs: [],
      errors: new Errors(),
      model: {
        deleted_reason: null
      }
    }
  },
  computed: {
    ...mapState('paymentTesting', ['resources', 'pagination']),
    dateFrom () {
      return moment(this.$store.state.paymentTesting.date_from, 'DD-MM-YYYY')
    },
    dateTo () {
      return moment(this.$store.state.paymentTesting.date_to, 'DD-MM-YYYY')
    },
    search: {
      get () {
        return this.$store.state.paymentTesting.search
      },
      set (newValue) {
        this.$store.commit('paymentTesting/SET_SEARCH', newValue)
        this.$store.commit('paymentTesting/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get () {
        return this.$store.state.paymentTesting.branch_id
      },
      set (newValue) {
        this.$store.commit('paymentTesting/SET_BRANCH_ID', newValue)
      }
    },
    columns () {
      return [
        { name: this.$t('paymentTesting.date') },
        { name: this.$t('paymentTesting.student') },
        { name: this.$t('paymentTesting.paymentNumber') },
        { name: this.$t('paymentTesting.subProgram') },
        { name: this.$t('paymentTesting.academicTerm') },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  methods: {
    ...mapActions('paymentTesting', ['destroy']),
    closeModal () {
      this.preview_pdf = false
      this.id = null
    },
    fetchData (attributes = {}) {
      this.loading = true
      this.$store
        .dispatch(
          'paymentTesting/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    dateRangeChange (dateRange) {
      this.$store.commit(
        'paymentTesting/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'paymentTesting/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },
    edit (record) {
      this.$store.commit('paymentTesting/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'payment-test-edit',
        params: { id: record.payment_id }
      })
    },
    pdfView (record) {
      this.preview_pdf = true
      this.id = record.payment_id
    },
    deleteRecord (record) {
      this.model.deleted_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('paymentTesting.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.destroy({
            id: record.payment_id,
            data: this.model
          })
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel () {}
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('paymentTesting/RESET_STATE')
    next()
  }
}
</script>
